"use client";

import { useLingui } from "@lingui/react/macro";
import { Text } from "@offstreetparking/design-system/typography";

export const OrDivider = () => {
	const { t } = useLingui();
	return (
		<div className="flex w-full items-center gap-2">
			<hr className="grow border-neutral-faded" />
			<Text intent="muted" size="sm">
				{t`OR`}
			</Text>
			<hr className="grow border-neutral-faded" />
		</div>
	);
};
